import React, { useState } from "react"

interface Address {
  street: string
  city: string
  state: string
  zipCode: string
  country: string
}

interface AddressFormProps {
  onSubmit: (address: Address) => void
  onCancel: () => void
  isLoading?: boolean
}

export function AddressForm({ onSubmit, onCancel, isLoading = false }: AddressFormProps) {
  const [address, setAddress] = useState<Address>({
    street: "",
    city: "",
    state: "",
    zipCode: "",
    country: "US"
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (address.street && address.city && address.state && address.zipCode) {
      onSubmit(address)
    }
  }

  const handleChange = (field: keyof Address, value: string) => {
    setAddress(prev => ({ ...prev, [field]: value }))
  }

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000001,
      backdropFilter: "blur(4px)",
    }}>
      <div style={{
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "24px",
        maxWidth: "400px",
        width: "90%",
        boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
      }}>
        <h3 style={{
          fontSize: "20px",
          fontWeight: "600",
          marginBottom: "16px",
          color: "#1f2937",
        }}>
          Delivery Address
        </h3>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "500", marginBottom: "4px", color: "#374151" }}>
              Street Address
            </label>
            <input
              type="text"
              value={address.street}
              onChange={(e) => handleChange("street", e.target.value)}
              required
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                fontSize: "14px",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "500", marginBottom: "4px", color: "#374151" }}>
                City
              </label>
              <input
                type="text"
                value={address.city}
                onChange={(e) => handleChange("city", e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "500", marginBottom: "4px", color: "#374151" }}>
                State
              </label>
              <input
                type="text"
                value={address.state}
                onChange={(e) => handleChange("state", e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>
          </div>

          <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "500", marginBottom: "4px", color: "#374151" }}>
                ZIP Code
              </label>
              <input
                type="text"
                value={address.zipCode}
                onChange={(e) => handleChange("zipCode", e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "500", marginBottom: "4px", color: "#374151" }}>
                Country
              </label>
              <select
                value={address.country}
                onChange={(e) => handleChange("country", e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              >
                <option value="GH">Ghana</option>
                <option value="NG">Nigeria</option>
                <option value="US">United States</option>
                <option value="CA">Canada</option>
                <option value="GB">United Kingdom</option>
                <option value="AU">Australia</option>
              </select>
            </div>
          </div>

          <div style={{ display: "flex", gap: "12px" }}>
            <button
              type="button"
              onClick={onCancel}
              style={{
                flex: 1,
                padding: "12px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                backgroundColor: "white",
                color: "#374151",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className={isLoading ? "loading-button" : ""}
              style={{
                flex: 1,
                padding: "12px 16px",
                border: "none",
                borderRadius: "8px",
                backgroundColor: isLoading ? "#9ca3af" : "#3b82f6",
                color: "white",
                fontSize: "14px",
                fontWeight: "500",
                cursor: isLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {isLoading && (
                <div className="loading-spinner" style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid transparent",
                  borderTop: "2px solid currentColor",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  marginRight: "8px"
                }} />
              )}
              {isLoading ? "Processing..." : "Continue"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}